import angular from 'angular';
import angularUiRouter from '@uirouter/angularjs';
import vcRecaptcha from 'angular-recaptcha';

export default angular.module('billingModule', [
    angularUiRouter,
    'billingApiModule',
    'shared',
    'ngAnimate',
    'asRangeLabel',
    vcRecaptcha
]);



// WEBPACK FOOTER //
// ./modules/billing/billing.module.js